import { render } from "./NetworkStatus.vue?vue&type=template&id=32551136&scoped=true"
import script from "./NetworkStatus.vue?vue&type=script&lang=js"
export * from "./NetworkStatus.vue?vue&type=script&lang=js"

import "./NetworkStatus.vue?vue&type=style&index=0&id=32551136&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32551136"],['__file',"resources/js/components/NetworkStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32551136"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32551136', __exports__)) {
    api.reload('32551136', __exports__)
  }
  
  module.hot.accept("./NetworkStatus.vue?vue&type=template&id=32551136&scoped=true", () => {
    api.rerender('32551136', render)
  })

}


export default __exports__